import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N200 } from '@atlaskit/theme/colors';

import {
	FlexNavigationContainer,
	TitleAndBreadcrumbsWrapper,
	ContentTypesHeaderContainer,
} from './contentTypesHeaderStyles';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BreadcrumbsSkeleton = styled.div({
	height: '12px',
	width: '74px',
	borderRadius: '16px',
	background: token('color.skeleton', '#091E420F'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BreadcrumbsSeparatorSkeleton = styled.div({
	margin: `0px ${token('space.050', '4px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:before': {
		flexShrink: 0,
		content: '"/"',
		color: token('color.background.accent.gray.subtlest', N200),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div<{ isTitle?: boolean }>({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ isTitle }) => (isTitle ? '24px' : '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleSkeleton = styled.div({
	height: '14px',
	width: '326px',
	borderRadius: '16px',
	background: token('color.skeleton', '#091E420F'),
});

type ContentTypesHeaderPlaceholderProps = {
	isFloating?: boolean;
};

export const ContentTypesHeaderPlaceholder: FC<ContentTypesHeaderPlaceholderProps> = ({
	isFloating,
}) => {
	return (
		<ContentTypesHeaderContainer isFloating={isFloating}>
			<FlexNavigationContainer data-testid="content-types-header-placeholder">
				<TitleAndBreadcrumbsWrapper>
					<SkeletonWrapper>
						<BreadcrumbsSkeleton />
						<BreadcrumbsSeparatorSkeleton data-testid="content-types-header-placeholder-breadcrumbs-separator" />
						<BreadcrumbsSkeleton data-testid="content-types-header-placeholder-breadcrumbs-skeleton" />
					</SkeletonWrapper>
					<SkeletonWrapper isTitle>
						<TitleSkeleton />
					</SkeletonWrapper>
				</TitleAndBreadcrumbsWrapper>
			</FlexNavigationContainer>
		</ContentTypesHeaderContainer>
	);
};
